import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MARKETPLACES } from "./data/marketplaceData";
import { MarketplaceGrid } from "./MarketplaceGrid";

export const MarketplaceList = () => (
  <Tabs defaultValue="global" className="w-full">
    <TabsList className="mb-4 h-auto flex-wrap justify-start">
      <TabsTrigger value="global">Mondial</TabsTrigger>
      <TabsTrigger value="usa">États-Unis</TabsTrigger>
      <TabsTrigger value="europe">Europe</TabsTrigger>
      <TabsTrigger value="asia_pacific">Asie-Pacifique</TabsTrigger>
      <TabsTrigger value="latin_america">Amérique Latine</TabsTrigger>
      <TabsTrigger value="africa">Afrique</TabsTrigger>
    </TabsList>
    {Object.entries(MARKETPLACES).map(([region, marketplaces]) => (
      <TabsContent key={region} value={region} className="mt-0">
        <MarketplaceGrid marketplaces={marketplaces} integrations={{}} onConnect={() => {}} isLoading={false} />
      </TabsContent>
    ))}
  </Tabs>
);
